import React, { useCallback, useContext } from "react";

import { useDispatch } from "react-redux";

import { Button, Heading, Text } from "@busbud/horizon";

import { Dialog } from "@app/components/dialog";
import { LiteAppContext } from "@app/context/lite-app-context";
import { helpUrl } from "@app/services/url-builders/company-pages-url-builder";
import { yieldToMain } from "@app/utils/scheduler-yield";

import { closeModal } from "../../../modules/checkout/actions";

export const HelpCenterRedirect: React.FC = () => {
  const { liteTranslator, locale } = useContext(LiteAppContext);
  const dispatch = useDispatch();

  const onClose = useCallback(async () => {
    await yieldToMain();
    dispatch(closeModal("help_center_redirect"));
  }, [dispatch]);

  return (
    <Dialog
      isOpen={true}
      onClose={onClose}
      className="m-[revert] h-fit max-h-fit w-[444px] max-w-[calc(100%-32px)]"
    >
      <Dialog.Header onClose={onClose} />
      <Dialog.Body>
        <Heading size="sm" as="h2" className="mb-300 text-center">
          {liteTranslator.t("!modal.help-center-redirect.title")}
        </Heading>

        <Text size="smLead" as="p" className="mb-300 text-center">
          {liteTranslator.t("!modal.help-center-redirect.body")}
        </Text>
        <Button
          appearance="primary"
          variant="contained"
          size="lg"
          className="w-full"
          onClick={() => {
            dispatch(closeModal("help_center_redirect"));
            window.location.href = helpUrl(locale);
          }}
        >
          {liteTranslator.t("!checkout.ancillary.continue")}
        </Button>
      </Dialog.Body>
    </Dialog>
  );
};

export default HelpCenterRedirect;
